/**
 * CampusCommentsSection: árbol de comentarios + input para escribir comentario nuevo.
 */
import React from 'react';
import { Loader2, Send, CornerDownRight, X } from 'lucide-react';
import { Button } from '../ui/button';
import MuroComentarios from './MuroComentarios';
import MentionInput from './MentionInput';

export default function CampusCommentsSection({ post, ctx }) {
  const postComments = ctx.commentsData[post.id] || [];
  const isLoadingComments = ctx.loadingComments[post.id];
  const commentText = ctx.commentInputs[post.id] || '';
  const isSendingComment = ctx.sendingComment[post.id];

  return (
    <div className="mt-3 pt-3 border-t" data-testid={`comments-section-${post.id}`}>
      {isLoadingComments ? (
        <div className="flex justify-center py-3">
          <Loader2 className="w-5 h-5 animate-spin text-gray-400" />
        </div>
      ) : (
        <>
          {postComments.length > 0 && (
            <MuroComentarios
              comentarios={postComments}
              postId={post.id}
              spaceId={ctx.spaceId}
              token={ctx.token}
              currentUserId={ctx.user?.id}
              esStaff={ctx.esCoordinadorODocente}
              onResponder={(payload) => ctx.enviarComentario(post.id, payload)}
              onEditar={(commentId, payload) => ctx.editarComentario(post.id, commentId, payload)}
              onEliminar={(commentId) => ctx.eliminarComentario(post.id, commentId)}
              onReaccionar={(commentId, tipo) => ctx.reaccionarComentario(post.id, commentId, tipo)}
            />
          )}

          {post.permite_comentarios !== false && (
            <CommentComposer post={post} ctx={ctx}
              commentText={commentText} isSendingComment={isSendingComment} />
          )}
        </>
      )}
    </div>
  );
}

function CommentComposer({ post, ctx, commentText, isSendingComment }) {
  const reply = ctx.replyingTo[post.id];
  return (
    <div data-testid={`comment-input-area-${post.id}`}>
      {reply && (
        <div className="flex items-center gap-2 text-xs text-violet-600 bg-violet-50 px-3 py-1.5 rounded-t-md border border-b-0 border-violet-200">
          <CornerDownRight className="w-3 h-3" />
          <span>Respondiendo a <strong>{reply.autorNombre}</strong></span>
          <button
            onClick={() => ctx.setReplyingTo((prev) => ({ ...prev, [post.id]: null }))}
            className="ml-auto text-violet-400 hover:text-violet-600"
          >
            <X className="w-3 h-3" />
          </button>
        </div>
      )}
      <div className="flex gap-2">
        <div className="w-7 h-7 bg-violet-100 rounded-full flex items-center justify-center text-violet-600 font-semibold text-xs flex-shrink-0">
          {(ctx.user?.email?.[0] || '?').toUpperCase()}
        </div>
        <div className="flex-1 flex flex-col gap-1.5">
          <MentionInput
            value={commentText}
            onChange={(text, menciones) => {
              ctx.setCommentInputs((prev) => ({ ...prev, [post.id]: text }));
              ctx.setCommentMenciones((prev) => ({ ...prev, [post.id]: menciones }));
            }}
            spaceId={ctx.spaceId}
            token={ctx.token}
            rows={2}
            placeholder={reply ? `Responder a ${reply.autorNombre}...` : 'Escribí un comentario… (usá @ para mencionar)'}
            testId={`comment-input-${post.id}`}
          />
          <div className="flex justify-end">
            <Button
              size="sm"
              onClick={() => ctx.enviarComentario(post.id)}
              disabled={!commentText.trim() || isSendingComment}
              className="h-8"
              data-testid={`send-comment-${post.id}`}
            >
              {isSendingComment
                ? <Loader2 className="w-4 h-4 animate-spin mr-1" />
                : <Send className="w-4 h-4 mr-1" />}
              Comentar
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
